import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { useDict } from '../../../contexts/LanguageContext';
import ROUTE_NAME from '../../../routes/RouteName';
import FaqContainer from './FaqContainer';

const RegistrationProcess = () => {
    const dict = useDict();

    return (
        <FaqContainer
            navigationActive="registrationprocess"
            prevLink={ROUTE_NAME.FAQ_ELIGIBILITY}
            prevTitle={dict.eligibility}
            nextLink={ROUTE_NAME.FAQ_INVEST_NOW}
            nextTitle={dict.investNowFaq}
        >
            <Card className="card--not-full-height">
                <CardBody className="documentation__card-body">
                    <div className="card__title">
                        <h3 className="bold-text" style={{ color: '#264391' }}>
                            {dict.financingPlatform}
                        </h3>
                    </div>
                    <div className="card__title">
                        <h4 className="bold-text" style={{ color: '#264391' }}>
                            {dict.registrationProcess}
                        </h4>
                    </div>
                    <p>
                        <strong>
                            {dict.registrationProcessTitle1}
                        </strong>
                    </p>
                    <p>
                        {dict.registrationProcessTitle1Text1}
                    </p>
                    <p>
                        {dict.registrationProcessTitle1Text2}
                    </p>
                    <p>
                        <strong>
                            {dict.registrationProcessTitle2}
                        </strong>
                    </p>
                    <p>
                        {dict.registrationProcessTitle2Text1}
                    </p>
                    <p>
                        <strong>
                            {dict.registrationProcessTitle3}
                        </strong>
                    </p>
                    <p>
                        {dict.registrationProcessTitle3Text1}
                    </p>
                    <ul>
                        <li>
                            <u>{dict.registrationProcessTitle3Text2}</u>
                            <ul>
                                <li>
                                    {dict.registrationProcessTitle3Text2List1}
                                </li>
                                <li>
                                    {dict.registrationProcessTitle3Text2List2}
                                </li>
                                <li>
                                    {dict.registrationProcessTitle3Text2List3}
                                </li>
                                <li>
                                    {dict.registrationProcessTitle3Text2List4}
                                </li>
                            </ul>
                        </li>
                        <li style={{ color: '#002060' }}>
                            <u>{dict.registrationProcessTitle3Text3}</u>
                            <ul style={{ color: '#002060' }}>
                                <li>
                                    {dict.registrationProcessTitle3Text3List1}
                                </li>
                                <li>
                                    {dict.registrationProcessTitle3Text3List2}
                                </li>
                                <li>
                                    {dict.registrationProcessTitle3Text3List3}
                                </li>
                            </ul>
                        </li>
                    </ul>
                    <p>
                        <strong>
                            {dict.registrationProcessTitle4}
                        </strong>
                    </p>
                    <p>
                        {dict.registrationProcessTitle4Text1}
                    </p>
                    <ul>
                        <li>{dict.registrationProcessTitle4Text1List1}</li>
                        <li>{dict.registrationProcessTitle4Text1List2}</li>
                        <li>{dict.registrationProcessTitle4Text1List3}</li>
                        <li>{dict.registrationProcessTitle4Text1List4}</li>
                        <li>{dict.registrationProcessTitle4Text1List5}</li>
                    </ul>
                    <p>
                        <strong>
                            {dict.registrationProcessTitle5}
                        </strong>
                    </p>
                    <p>
                        {dict.registrationProcessTitle5Text1}
                    </p>
                    <p>
                        <strong>
                            {dict.registrationProcessTitle6}
                        </strong>
                    </p>
                    <p>
                        {dict.registrationProcessTitle6Text1}
                    </p>
                </CardBody>
            </Card>
        </FaqContainer>
    );
};

export default RegistrationProcess;
